import { IonPage } from '@ionic/react';
import styled from 'styled-components';

export const IonPageWrapper = styled(IonPage)`
  .MuiFormControl-root {
    min-width: 200px;
  }
`;
